(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azora-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const cards = [...root.querySelectorAll('.azora-review-card')];
      if (!cards.length) return;
      const current = root.querySelector('.azora-reviews__current');
      const track = root.querySelector('.azora-reviews__track');
      const ticks = [...root.querySelectorAll('.azora-reviews__tick')];
      const previousButton = root.querySelector('[data-review-prev]');
      const nextButton = root.querySelector('[data-review-next]');
      let active = 0;
      let startX = 0;
      let dragStartActive = 0;
      let timer;
      let dragging = false;

      const update = () => {
        cards.forEach((card, index) => {
          card.classList.remove('is-active', 'is-prev', 'is-next', 'is-far-prev', 'is-far-next');
          let distance = index - active;
          if (distance > cards.length / 2) distance -= cards.length;
          if (distance < -cards.length / 2) distance += cards.length;
          if (distance === 0) card.classList.add('is-active');
          if (distance === -1) card.classList.add('is-prev');
          if (distance === 1) card.classList.add('is-next');
          if (distance === -2) card.classList.add('is-far-prev');
          if (distance === 2) card.classList.add('is-far-next');
          card.setAttribute('aria-hidden', distance === 0 ? 'false' : 'true');
        });
        current.textContent = String(active + 1).padStart(2, '0');
        ticks.forEach((tick, index) => {
          const selected = index === active;
          tick.classList.toggle('is-active', selected);
          if (selected) {
            tick.setAttribute('aria-current', 'true');
          } else {
            tick.removeAttribute('aria-current');
          }
        });
      };

      const move = (step) => {
        active = (active + step + cards.length) % cards.length;
        update();
      };

      const stopAuto = () => window.clearInterval(timer);
      const startAuto = () => {
        stopAuto();
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => move(1), 4200);
        }
      };

      const settleTrack = () => {
        root.classList.remove('is-dragging');
        track.style.transform = 'translate3d(0, 0, 0)';
      };

      track.addEventListener('pointerdown', (event) => {
        dragging = true;
        startX = event.clientX;
        dragStartActive = active;
        stopAuto();
        root.style.setProperty('--slide-duration', '260ms');
        root.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointerup', () => {
        dragging = false;
        settleTrack();
        root.style.setProperty('--slide-duration', '480ms');
        startAuto();
      });
      track.addEventListener('pointercancel', () => {
        dragging = false;
        settleTrack();
        startAuto();
      });
      track.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        event.preventDefault();
        const distance = event.clientX - startX;
        const steps = Math.round(distance / 78);
        const nextActive = (dragStartActive - steps + cards.length * 10) % cards.length;
        if (nextActive !== active) {
          active = nextActive;
          update();
        }
        const remainder = distance - steps * 78;
        track.style.transform = `translate3d(${remainder * .38}px, 0, 0)`;
      });
      previousButton.addEventListener('click', () => {
        stopAuto();
        move(-1);
        startAuto();
      });
      nextButton.addEventListener('click', () => {
        stopAuto();
        move(1);
        startAuto();
      });
      ticks.forEach((tick, index) => {
        tick.addEventListener('click', () => {
          stopAuto();
          active = index;
          update();
          startAuto();
        });
      });
      root.addEventListener('mouseenter', stopAuto);
      root.addEventListener('mouseleave', () => {
        if (!dragging) startAuto();
      });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(-1);
        if (event.key === 'ArrowRight') move(1);
      });
      update();
      startAuto();
    };

    document.querySelectorAll('[id^="AzoraReviews-"]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[id^="AzoraReviews-"]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
